export const enum ComplaintStatusEnum {
  Resolved = 10
}



// WEBPACK FOOTER //
// ./src/app/core/enums/complaint-status.enum.ts